// extracted by mini-css-extract-plugin
export default {"root":"errorView_root__HAFDd"};